/* soundcore Mega Menu v2.0 — Dawn 15.5.0 */
if (!customElements.get('soundcore-menu')) {
  customElements.define('soundcore-menu', class extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('[data-sc-menu-item]')];
      this.drawer = this.querySelector('.sc-mobile');
      this.trigger = this.querySelector('.sc-menu__mobile-trigger');
      this.closeTimer = null;
      this.lastFocus = null;

      this.items.forEach((item) => {
        const link = item.querySelector(':scope > .sc-menu__link');
        const panel = item.querySelector(':scope > [data-sc-panel]');
        if (!link || !panel) return;
        item.addEventListener('pointerenter', () => this.openItem(item));
        item.addEventListener('pointerleave', () => this.scheduleClose(item));
        item.addEventListener('focusin', () => this.openItem(item));
        item.addEventListener('focusout', (event) => {
          if (!item.contains(event.relatedTarget)) this.scheduleClose(item, 80);
        });
        link.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowDown') { event.preventDefault(); this.openItem(item); panel.querySelector('a,button')?.focus(); }
        });
      });

      this.querySelectorAll('[data-sc-collection-tab]').forEach((tab) => {
        tab.addEventListener('mouseenter', () => this.switchCollection(tab));
        tab.addEventListener('focus', () => this.switchCollection(tab));
        tab.addEventListener('click', () => this.switchCollection(tab));
      });
      this.querySelectorAll('[data-sc-mobile-tab]').forEach((tab) => {
        tab.addEventListener('click', () => this.switchMobileCollection(tab));
      });
      this.carouselTimers = [];
      this.initCarousels();
      this.trigger?.addEventListener('click', () => this.openDrawer());
      this.querySelectorAll('[data-sc-close]').forEach((button) => button.addEventListener('click', () => this.closeDrawer()));
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        if (this.drawer && !this.drawer.hidden) this.closeDrawer();
        else this.closeAll();
      });
      this.updatePanelTop();
      this.onResize = () => this.updatePanelTop();
      window.addEventListener('resize', this.onResize, { passive: true });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
      this.carouselTimers?.forEach((timer) => clearInterval(timer));
    }
    updatePanelTop() {
      const header = this.closest('.shopify-section-header-sticky, .shopify-section-group-header-group') || document.querySelector('.header-wrapper');
      const bottom = header ? header.getBoundingClientRect().bottom : this.getBoundingClientRect().bottom;
      this.style.setProperty('--sc-panel-top', `${Math.max(0, Math.round(bottom))}px`);
    }
    openItem(item) {
      clearTimeout(this.closeTimer);
      this.updatePanelTop();
      this.items.forEach((other) => {
        const open = other === item;
        other.classList.toggle('is-open', open);
        other.querySelector(':scope > .sc-menu__link')?.setAttribute('aria-expanded', String(open));
      });
    }
    scheduleClose(item, delay = 260) {
      clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => {
        item.classList.remove('is-open');
        item.querySelector(':scope > .sc-menu__link')?.setAttribute('aria-expanded', 'false');
      }, delay);
    }
    closeAll() {
      clearTimeout(this.closeTimer);
      this.items.forEach((item) => {
        item.classList.remove('is-open');
        item.querySelector(':scope > .sc-menu__link')?.setAttribute('aria-expanded', 'false');
      });
    }
    switchCollection(tab) {
      const root = tab.closest('.sc-collection');
      const key = tab.dataset.scCollectionTab;
      root.querySelectorAll('[data-sc-collection-tab]').forEach((button) => {
        const active = button === tab;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', String(active));
      });
      root.querySelectorAll('[data-sc-collection-pane]').forEach((pane) => {
        const active = pane.dataset.scCollectionPane === key;
        pane.classList.toggle('is-active', active);
        pane.hidden = !active;
        if (active) root.querySelector('[data-sc-view-all]').href = pane.dataset.url;
      });
    }
    switchMobileCollection(tab) {
      const root = tab.closest('[data-sc-mobile-collection]');
      const key = tab.dataset.scMobileTab;
      if (!root) return;
      root.querySelectorAll('[data-sc-mobile-tab]').forEach((button) => {
        const active = button === tab;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', String(active));
      });
      root.querySelectorAll('[data-sc-mobile-pane]').forEach((pane) => {
        const active = pane.dataset.scMobilePane === key;
        pane.hidden = !active;
        if (active) root.querySelector('[data-sc-mobile-view-all]').href = pane.dataset.url;
      });
    }
    initCarousels() {
      this.querySelectorAll('[data-sc-carousel]').forEach((carousel) => {
        const track = carousel.querySelector('[data-sc-carousel-track]');
        const slides = [...carousel.querySelectorAll('[data-sc-carousel-slide]')];
        const dots = carousel.querySelector('[data-sc-carousel-dots]');
        const previous = carousel.querySelector('[data-sc-carousel-prev]');
        const next = carousel.querySelector('[data-sc-carousel-next]');
        let index = 0;
        carousel.dataset.count = String(slides.length);
        if (!track || slides.length === 0) { carousel.hidden = true; return; }

        const show = (nextIndex) => {
          index = (nextIndex + slides.length) % slides.length;
          track.style.transform = `translateX(-${index * 100}%)`;
          slides.forEach((slide, slideIndex) => slide.setAttribute('aria-hidden', String(slideIndex !== index)));
          dots?.querySelectorAll('button').forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
        };
        slides.forEach((slide, slideIndex) => {
          if (!dots) return;
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = slideIndex === 0 ? 'is-active' : '';
          dot.setAttribute('aria-label', `前往第 ${slideIndex + 1} 張`);
          dot.addEventListener('click', () => show(slideIndex));
          dots.appendChild(dot);
        });
        previous?.addEventListener('click', () => show(index - 1));
        next?.addEventListener('click', () => show(index + 1));

        if (carousel.dataset.autoplay === 'true' && slides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          const interval = Number(carousel.dataset.interval) || 5000;
          let timer = setInterval(() => show(index + 1), interval);
          this.carouselTimers.push(timer);
          carousel.addEventListener('pointerenter', () => clearInterval(timer));
          carousel.addEventListener('pointerleave', () => { timer = setInterval(() => show(index + 1), interval); this.carouselTimers.push(timer); });
        }
        show(0);
      });
    }
    openDrawer() {
      if (!this.drawer) return;
      this.lastFocus = document.activeElement;
      this.drawer.hidden = false;
      this.trigger?.setAttribute('aria-expanded', 'true');
      document.body.classList.add('sc-menu-lock');
      this.drawer.querySelector('[data-sc-close]:not(.sc-mobile__scrim)')?.focus();
    }
    closeDrawer() {
      if (!this.drawer) return;
      this.drawer.hidden = true;
      this.trigger?.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('sc-menu-lock');
      this.lastFocus?.focus();
    }
  });
}
